import { List, Stack } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { Repeat } from "lib/@components/repeat"
import { NoResults } from "lib/@components/no-results/no-results"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { MacroBinItem } from "./macro-bin-item"

export function MacroBinList({ macros = [] }) {
    return (
        <If truthy={macros.length > 0}>
            <Bound onRestore={handleRestore}>
                <List disablePadding>
                    <Repeat list={macros} pass="macro" keyFn="id" item={<MacroBinItem />} />
                </List>
            </Bound>
            <Else>
                <Stack sx={{ px: 2, py: 3 }} alignItems="center" data-cy="macro-bin-empty">
                    <NoResults mt={0} width={220}>
                        No deleted macros.
                    </NoResults>
                </Stack>
            </Else>
        </If>
    )

    function handleRestore() {
        // no-op; GraphQL invalidations refresh deleted list after restore
    }
}
